module.exports = __webpack_public_path__ + "img/team-mosaic-03.d7fa6cc1.jpg";